// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file quanterix/common/extensions/v1/target_entity.proto (package quanterix.common.extensions.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file quanterix/common/extensions/v1/target_entity.proto.
 */
export const file_quanterix_common_extensions_v1_target_entity: GenFile = /*@__PURE__*/
  fileDesc("CjJxdWFudGVyaXgvY29tbW9uL2V4dGVuc2lvbnMvdjEvdGFyZ2V0X2VudGl0eS5wcm90bxIecXVhbnRlcml4LmNvbW1vbi5leHRlbnNpb25zLnYxIkwKDFRhcmdldEVudGl0eRIUCgdwYWNrYWdlGAEgASgJSACIAQESEQoEbmFtZRgCIAEoCUgBiAEBQgoKCF9wYWNrYWdlQgcKBV9uYW1lYgZwcm90bzM");

/**
 * Represents a target protobuf entity of either Message or Enum
 *
 * @generated from message quanterix.common.extensions.v1.TargetEntity
 */
export type TargetEntity = Message<"quanterix.common.extensions.v1.TargetEntity"> & {
  /**
   * Fully-qualified package name containing the entity
   *
   * @generated from field: optional string package = 1;
   */
  package?: string;

  /**
   * Name of the Message or Enum
   *
   * @generated from field: optional string name = 2;
   */
  name?: string;
};

/**
 * Describes the message quanterix.common.extensions.v1.TargetEntity.
 * Use `create(TargetEntitySchema)` to create a new message.
 */
export const TargetEntitySchema: GenMessage<TargetEntity> = /*@__PURE__*/
  messageDesc(file_quanterix_common_extensions_v1_target_entity, 0);

